import stateFetch from '../../../assets/js/modules/fetchState';
import {bind} from '../../../assets/js/modules/bind';
import {eventHandler} from '../../../assets/js/components/eventHandler';
import {copyToClipboard} from './copyToClipboard';
import {verifyCustomUiElements} from './verifyCustomUiElements';
import {focusInvalidControl} from './focusInvalidControl';
import {printDialog} from './printDialog';
import {showControlSelectMaskText} from './showControlSelectMaskText';
import {showControlPatternMessage} from './showControlPatternMessage';
import {togglePasswordInputType} from './togglePasswordInputType';
import {addLinkButtonKeyboardSupport} from './addLinkButtonKeyboardSupport';
import {loadDependency} from './loadDependency';

// Core
eventHandler();
stateFetch();

// Modules
addLinkButtonKeyboardSupport();
copyToClipboard();
focusInvalidControl();
loadDependency();
printDialog();
showControlPatternMessage();
showControlSelectMaskText();
togglePasswordInputType();
verifyCustomUiElements();

// NOTE: `bind` has to come last to bind all other JS
bind();
